import { useContext, useCallback, useState } from "react";
import { AnchoredModal } from "../../../../components/modal/anchored";
import { Context } from "../../../../context";
import { AddDepartmentModalWrapper } from "./styled";
import { P } from "../../../../components/typography/styled";
import { useEffect } from "react";

export const AddDepartmentModal = ({
  handleActionItemClick,
  anchorElement,
}) => {
  const { isAddDepartmentModalOpen, setIsAddDepartmentModalOpen } =
    useContext(Context);
  const [modalPosition, setModalPosition] = useState({
    top: "auto",
    right: "var(--cardPadding)",
  });

  const handleCloseModal = useCallback(() => {
    setIsAddDepartmentModalOpen(false);
  }, [setIsAddDepartmentModalOpen]);

  useEffect(() => {
    const handleScroll = () => {
      handleCloseModal();
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleCloseModal]);

  useEffect(() => {
    if (isAddDepartmentModalOpen && anchorElement) {
      const rect = anchorElement.getBoundingClientRect();
      setModalPosition({
        top: `${rect.bottom + 8}px`,
        right: `${window.innerWidth - rect.right}px`,
      });
    }
  }, [isAddDepartmentModalOpen, anchorElement]);

  return (
    <AnchoredModal
      open={isAddDepartmentModalOpen}
      onClose={handleCloseModal}
      className={"add-department-modal"}
      height={"auto"}
      width={"auto"}
      top={modalPosition.top}
      right={modalPosition.right}
    >
      <AddDepartmentModalWrapper>
        <div
          className="option"
          onClick={(e) => handleActionItemClick(e, "download-template")}
        >
          <P>Download Template</P>
        </div>
        <div
          className="option"
          onClick={(e) => handleActionItemClick(e, "bulk-upload")}
        >
          <P>Upload CSV</P>
        </div>
      </AddDepartmentModalWrapper>
    </AnchoredModal>
  );
};
